import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { LazyLoadEvent } from 'primeng/api';
import { Currency } from 'src/app/shared/models/currency.model';
import { GiftCardContainer, GiftCardStatus } from 'src/app/shared/models/gift-card.model';
import { User } from 'src/app/shared/models/user.model';
import { ReportService } from 'src/app/shared/service/report.service';
import { Pagination } from '../../../../../shared/models/pagination.model';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-gift-card',
  templateUrl: './gift-card.component.html',
  styleUrls: ['./gift-card.component.scss']
})
export class GiftCardComponent implements OnInit {
  @Input() set CreatedGiftCardUserId(users: User[]) {
    this._createdGiftCardUserId = users ?? [];
  }

  @Input() set RedeemedGiftCardUserId(users: User[]) {
    this._redeemedGiftCardUserId = users ?? [];
    this.status = GiftCardStatus.USED;
  }

  @Input() set currencyIds(currencies: Currency[]) {
    this._currency = currencies ?? [];
  }

  _redeemedGiftCardUserId: User[] = [];
  _createdGiftCardUserId: User[] = [];
  _currency: Currency[] = [];
  response: Pagination<GiftCardContainer> = {
    data: [],
    page: 0,
    totalRecords: 0,
    perPage: 0,
    totalPages: 0
  };
  loading = false;
  reportType: string = 'deposit';
  limit = 15;
  page = 1;
  status: GiftCardStatus | null = null;
  GiftCardStatus = GiftCardStatus;

  constructor(private router: Router, private reportService: ReportService) {
    this.getGiftCardsList();
  }

  getGiftCardsList(event: LazyLoadEvent = {}): void {
    this.loading = true;
    if (event.first !== undefined && event.rows !== undefined) {
      this.page = event?.first / this.limit + 1;
    }
    const currenciesId = this._currency.map((currency) => currency.id);
    const createdGiftCardUserIds = this._createdGiftCardUserId.map((user) => user.id);
    const redeemedGiftCardUserIds = this._redeemedGiftCardUserId.map((user) => user.id);
    this.reportService
      .getGiftCards(
        createdGiftCardUserIds,
        redeemedGiftCardUserIds,
        this.status,
        currenciesId,
        this.page,
        this.limit
      )
      .subscribe((res: Pagination<GiftCardContainer>) => {
        this.response = res;
        this.loading = false;
      });
  }

  ngOnInit(): void {
    if (this.router.url.includes('withdraw')) {
      this.reportType = 'withdraw';
    }
  }
}
